import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import { OverviewModal } from '..';
import getLang from 'academy-common-lib/utils/getLang';
import { jsx as _jsx } from "react/jsx-runtime";
const OverviewModalRouter = () => {
  const [{
    overviewType,
    overviewEntityId,
    overviewLanguage,
    overviewSource
  }] = useSearchParams();
  if (overviewType && overviewEntityId && !isNaN(Number(overviewEntityId))) {
    return /*#__PURE__*/_jsx(OverviewModal, {
      entityId: Number(overviewEntityId),
      language: overviewLanguage !== null && overviewLanguage !== void 0 ? overviewLanguage : getLang(),
      source: overviewSource,
      type: overviewType
    });
  }
  return null;
};
export default OverviewModalRouter;